import { render, staticRenderFns } from "./GerarRelatorioImoveis.vue?vue&type=template&id=5b580e04&scoped=true&"
import script from "./GerarRelatorioImoveis.vue?vue&type=script&lang=js&"
export * from "./GerarRelatorioImoveis.vue?vue&type=script&lang=js&"
import style0 from "./GerarRelatorioImoveis.vue?vue&type=style&index=0&id=5b580e04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b580e04",
  null
  
)

export default component.exports